import { Sparkles } from "lucide-react";

export default function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div data-testid={testid} className="flex items-end justify-between flex-wrap gap-3 mb-6">
      <div>
        {eyebrow && (
          <div className="flex items-center gap-2 text-brand-orange">
            <Sparkles size={14} />
            <span className="small-caps">{eyebrow}</span>
          </div>
        )}
        <h1 className="font-serif text-3xl sm:text-4xl text-brand-navy tracking-tight mt-1">
          {title}
        </h1>
        {description && <p className="text-gray-500 mt-1 max-w-2xl">{description}</p>}
      </div>
      <div className="flex gap-2">{actions}</div>
    </div>
  );
}
